import { Injectable } from '@angular/core';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { Y42FeatureType } from '@y42/json-schema';
import { StatusAlertQuery } from './status-alert.query';

@Injectable({ providedIn: 'root' })
export class StatusAlertAclService extends AbstractFeatureAclService<Y42FeatureType.StatusAlert> {
  constructor(query: StatusAlertQuery) {
    super({
      featureType: Y42FeatureType.StatusAlert,
      query,
    });
  }
}
